// export const BASE_URL = "https://api.elite-sapphire.com/api";
export const BASE_URL = "https://data-api.connectwave-cp.com/api";
// export const BASE_URL = "http://localhost:7801/api";
// export const BASE_URL=" http://103.189.173.7:7800/api";
